import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from "./store/store";
import axios from "axios";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: { name: "Home" },
      component: () => import("@/layouts/full-layout/Layout"),
      meta: {
        requiresPermission: true,
        permission: ["root", "admin"],
      },
      children: [
        {
          name: "Home",
          path: "",
          component: () => import("@/views/Home"),
        },
        {
          name: "Users",
          path: "users",
          component: () => import("@/views/admin/Users"),
        },
        {
          name: "Units",
          path: "units",
          component: () => import("@/views/admin/Units"),
        },
        {
          name: "Hawkers",
          path: "hawkers",
          component: () => import("@/views/admin/Hawkers"),
        },
        {
          name: "Reports",
          path: "reports",
          component: () => import("@/views/admin/Reports"),
        },
      ],
    },
    {
      path: "/k",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: {
        requiresPermission: true,
        permission: "admin",
      },
      children: [
        {
          name: "Products",
          path: "products",
          component: () => import("@/views/admin/Products"),
        },
        {
          name: "Kits",
          path: "kits",
          component: () => import("@/views/admin/Kits"),
        },
      ],
    },

    {
      path: "/operacao",
      component: () => import("@/views/operation/Operation"),
      meta: {
        requiresLogin: true,
      },
    },

    {
      path: "/auth",
      redirect: { name: "BoxedLogin" },
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "BoxedLogin",
          path: "signin",
          component: () => import("@/views/authentication/BoxedLogin"),
        },
        // {
        //   name: "Error",
        //   path: "error",
        //   component: () => import("@/views/authentication/Error"),
        // },
      ],
    },

    {
      path: "*",
      redirect: "/",
    },
  ],
});

import NProgress from "nprogress";

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

// router.beforeEach(async (to, from, next) => {
//   let user = await store.getters.GET_USER;

//   if (user) {
//     await axios
//       .post(`${process.env.VUE_APP_BASE_URL}/validate_token`, {
//         token: user.token,
//       })
//       .then(() => store.dispatch("SET_USER", user))
//       .catch(() => store.dispatch("LOGOUT"));
//   }

//   to.matched.some((record) => {
//     if (record.meta.requiresLogin) user ? next() : next({ path: "/auth" });
//     else if (record.meta.requiresPermission) {
//       if (!user) next({ path: "/auth" });
//       if (store.getters.GET_PERMISSION("root")) next();
//       store.getters.GET_PERMISSION(record.meta.permission)
//         ? next()
//         : next({ path: "/operacao" });
//     } else {
//       next();
//     }
//   });
// });

router.beforeEach(async (to, from, next) => {
  let user = store.getters.GET_USER; // não precisa de await, getter não é async

  if (user) {
    try {
      await axios.post(`${process.env.VUE_APP_BASE_URL}/validate_token`, {
        token: user.token,
      });
      await store.dispatch("SET_USER", user);
    } catch (e) {
      await store.dispatch("LOGOUT");
      user = null;
    }
  }

  const requiresLogin = to.matched.some((record) => record.meta.requiresLogin);
  const requiresPermission = to.matched.some(
    (record) => record.meta.requiresPermission
  );

  // 1) Se precisa de login e não tem usuário -> login
  if ((requiresLogin || requiresPermission) && !user) {
    return next({ path: "/auth" });
  }

  // 2) Se precisa de permissão
  if (requiresPermission) {
    // root entra em tudo
    if (store.getters.GET_PERMISSION("root")) {
      return next();
    }

    // Junta todas as permissões exigidas pelos records da rota
    let requiredPermissions = [];

    to.matched.forEach((record) => {
      if (record.meta.requiresPermission) {
        const p = record.meta.permission;
        if (Array.isArray(p)) {
          requiredPermissions = requiredPermissions.concat(p);
        } else if (p) {
          requiredPermissions.push(p);
        }
      }
    });

    // Verifica se o usuário tem pelo menos UMA das permissões
    const hasPermission = requiredPermissions.some((perm) =>
      store.getters.GET_PERMISSION(perm)
    );

    if (!hasPermission) {
      return next({ path: "/operacao" });
    }

    // tem permissão
    return next();
  }

  // 3) Rotas que não precisam de nada especial
  return next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
